import React, { useState } from 'react';

import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ReconciliationFilters = ({ onFilterChange, onExport }) => {
  const [filters, setFilters] = useState({
    bank: '',
    merchantTier: '',
    volumeRange: '',
    reconciliationStatus: ''
  });

  const bankOptions = [
    { value: 'all', label: 'Semua Bank' },
    { value: 'bca', label: 'Bank BCA' },
    { value: 'mandiri', label: 'Bank Mandiri' },
    { value: 'bni', label: 'Bank BNI' },
    { value: 'bri', label: 'Bank BRI' },
    { value: 'permata', label: 'Bank Permata' }
  ];

  const merchantTierOptions = [
    { value: 'all', label: 'Semua Tier' },
    { value: 'enterprise', label: 'Enterprise' },
    { value: 'business', label: 'Business' },
    { value: 'starter', label: 'Starter' }
  ];

  const volumeRangeOptions = [
    { value: 'all', label: 'Semua Volume' },
    { value: 'low', label: '< Rp 10 Juta' },
    { value: 'medium', label: 'Rp 10 Juta - Rp 100 Juta' },
    { value: 'high', label: 'Rp 100 Juta - Rp 1 Miliar' },
    { value: 'very-high', label: '> Rp 1 Miliar' }
  ];

  const reconciliationStatusOptions = [
    { value: 'all', label: 'Semua Status' },
    { value: 'matched', label: 'Cocok' },
    { value: 'pending', label: 'Pending Review' },
    { value: 'discrepancy', label: 'Ada Perbedaan' },
    { value: 'resolved', label: 'Terselesaikan' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      bank: '',
      merchantTier: '',
      volumeRange: '',
      reconciliationStatus: ''
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-elevation-1 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Filter Lanjutan</h3>
        <Button variant="ghost" size="sm" iconName="RotateCcw" onClick={handleReset}>
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Bank Settlement"
          options={bankOptions}
          value={filters?.bank}
          onChange={(value) => handleFilterChange('bank', value)}
          placeholder="Pilih bank"
        />
        <Select
          label="Tier Merchant"
          options={merchantTierOptions}
          value={filters?.merchantTier}
          onChange={(value) => handleFilterChange('merchantTier', value)}
          placeholder="Pilih tier"
        />
        <Select
          label="Rentang Volume"
          options={volumeRangeOptions}
          value={filters?.volumeRange}
          onChange={(value) => handleFilterChange('volumeRange', value)}
          placeholder="Pilih rentang"
        />
        <Select
          label="Status Rekonsiliasi"
          options={reconciliationStatusOptions}
          value={filters?.reconciliationStatus}
          onChange={(value) => handleFilterChange('reconciliationStatus', value)}
          placeholder="Pilih status"
        />
      </div>
      <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 pt-4 border-t border-border">
        <Button variant="default" iconName="Search" className="flex-1 md:flex-initial">
          Terapkan Filter
        </Button>
        <Button variant="outline" iconName="Download" onClick={onExport} className="flex-1 md:flex-initial">
          Ekspor Laporan
        </Button>
        <Button variant="outline" iconName="FileText" className="flex-1 md:flex-initial">
          Dokumentasi Pajak
        </Button>
        <Button variant="outline" iconName="History" className="flex-1 md:flex-initial">
          Audit Trail
        </Button>
      </div>
    </div>
  );
};

export default ReconciliationFilters;